import type { ReactNode } from 'react';
import { useHierarchy } from '../hierarchy/HierarchyProvider';
import { AppSidebar } from './layout/app-sidebar';
import { Badge } from './ui';
import { Separator } from './ui/separator';
import { SidebarInset, SidebarProvider, SidebarTrigger } from './ui/sidebar';

const CONNECTION_LABEL = {
  connecting: 'Conectando…',
  open: 'En vivo',
  closed: 'Sin conexión en vivo',
} as const;

/**
 * Cascarón del panel (rediseño shadcn/ui — sistema de sidebar completo).
 *
 * `AppSidebar` reemplaza el `<aside>` fijo de antes: ahora colapsa a modo
 * icono (`Cmd/Ctrl+B`), y el árbol Cliente→Sucursal→Nodo que vivía siempre
 * visible se fue con `HierarchySidebar` — su lugar lo ocupa el selector
 * rápido (`NodeSwitcher`, dentro de `AppSidebar`), que no crece con el
 * parque de nodos porque no está siempre montado. "Mi cuenta" y "Salir" ya
 * no van en esta cabecera: viven en el menú de `NavUser`, al pie del sidebar.
 */
export function Layout({ children }: { children: ReactNode }) {
  const { connection } = useHierarchy();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex items-center gap-2 border-b border-black/5 bg-card px-4 py-2.5 text-sm shadow-sm dark:border-white/5">
          <SidebarTrigger />
          <Separator orientation="vertical" className="h-4" />
          <div className="flex-1" />
          <Badge tone={connection === 'open' ? 'ok' : 'neutral'}>
            {CONNECTION_LABEL[connection]}
          </Badge>
        </header>
        <main className="flex-1 p-6">{children}</main>
      </SidebarInset>
    </SidebarProvider>
  );
}
